import React, { useState } from "react";
import {
  Button,
  Card,
  CardTitle,
  CardBody,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { URL } from "../../api";
import axiosInstance from "../../Request";
import { useEffect } from "react";


const Credit = ({ cid, lid, name_validation_data, nameMatchAverage }) => {
  const [nameValidationModal, setNameValidationModal] = useState(false);
  const [documentData, setDocumentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshingRowIds, setRefreshingRowIds] = useState(new Set());
  const [calculatedMatchAverage, setCalculatedMatchAverage] = useState(null);
  

  useEffect(() => {
  const fetchInitialData = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`${URL.NAME_MATCH}?customer_id=${cid}`);
      const data = response.data;
      const processed = preprocessDocumentData(data);
      setDocumentData(processed);

      const validMatches = processed.filter(d => typeof d.matched_percentage === 'number');
      if (validMatches.length > 0) {
        const total = validMatches.reduce((sum, d) => sum + d.matched_percentage, 0);
        const avg = Math.round(total / validMatches.length);
        setCalculatedMatchAverage(avg);
      } else {
        setCalculatedMatchAverage(null);
      }
    } catch (error) {
      console.error("Error fetching initial name match:", error);
    }
    setLoading(false);
  };

  fetchInitialData();
}, [cid]); 


//   const toggleNameValidationModal = async () => {
//     if (!nameValidationModal) {
//       setLoading(true);
//       try {
//   const response = await axiosInstance.get(`${URL.NAME_MATCH}?customer_id=${cid}`);
//   const data = response.data;
//   setDocumentData(preprocessDocumentData(data));
// } catch (error) {
//   console.error("Error fetching documents:", error);
// }
// setLoading(false);
//     }
//     setNameValidationModal(!nameValidationModal);
//   };

const toggleNameValidationModal = async () => {
  if (!nameValidationModal) {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`${URL.NAME_MATCH}?customer_id=${cid}`);
      const data = response.data;
      const processed = preprocessDocumentData(data);
      setDocumentData(processed);

      // Calculate average match percentage
      const validMatches = processed.filter(d => typeof d.matched_percentage === 'number');
      if (validMatches.length > 0) {
        const total = validMatches.reduce((sum, d) => sum + d.matched_percentage, 0);
        const avg = Math.round(total / validMatches.length);
        setCalculatedMatchAverage(avg);
      } else {
        setCalculatedMatchAverage(null);
      }
    } catch (error) {
      console.error("Error fetching documents:", error);
    }
    setLoading(false);
  }
  setNameValidationModal(!nameValidationModal);
};


  const normalizeType = (type) => {
    const lower = type?.toLowerCase() || "";
    if (lower.includes("aadhaar") || lower.includes("aadhar")) return "aadhaar";
    if (lower.includes("bank")) return "bank";
    if (lower.includes("pan")) return "pan";
    return lower;
  };

  const getIdKeyByType = (type) => {
    switch (normalizeType(type)) {
      case "aadhaar":
        return "aadhaar_id";
      case "pan":
        return "pan_id";
      case "bank":
        return "bank_id";
      default:
        return "id";
    }
  };

  const refreshDocument = async (type, localIndex, documentId) => {
  const cleanType = normalizeType(type);
  const idKey = getIdKeyByType(cleanType);

  try {
    // Step 1: POST to refresh
    await axiosInstance.post(`${URL.REFRESH_SCORE}?customer_id=${cid}`, {
      customer_id: cid,
      type: cleanType,
      localIndex,
      document_id: documentId,
      [idKey]: documentId,
    });

    // Step 2: GET updated data
    const getResponse = await axiosInstance.get(`${URL.NAME_MATCH}?customer_id=${cid}`);
    const allDocuments = getResponse.data;
    const preprocessed = preprocessDocumentData(allDocuments);

    // Step 3: Update only the refreshed row
    const updatedRow = preprocessed.find((item) => item.id === documentId);
    if (updatedRow) {
      setDocumentData((prevData) =>
        prevData.map((item) =>
          item.id === documentId ? updatedRow : item
        )
      );
    }
  } catch (error) {
    console.error("Error during refresh:", error);
      alert(`Refresh failed: ${error.message}`);
    }
  };

  const handleRefreshRow = async (type, localIndex, documentId) => {
    setRefreshingRowIds((prev) => new Set(prev).add(documentId));
    try {
      await refreshDocument(type, localIndex, documentId);
    } finally {
      setRefreshingRowIds((prev) => {
        const newSet = new Set(prev);
        newSet.delete(documentId);
        return newSet;
      });
    }
  };

  const preprocessDocumentData = (data) => {
    const typeCounters = {};
    return data.map((item) => {
      const cleanType = normalizeType(item.type);
      typeCounters[cleanType] = (typeCounters[cleanType] || 0) + 1;
      return {
        ...item,
        cleanType,
        localIndex: typeCounters[cleanType] - 1,
      };
    });
  };

  return (
    <>
      <Col xs="6" sm="4" md="3">
        <Card className="card-stats mb-4">
          <CardBody>
            <Row>
              <div className="col">
                <CardTitle tag="h5" className="text-uppercase text-muted mb-0">
                  Names MATCH
                </CardTitle>
                <a className="clickable" onClick={toggleNameValidationModal}>
                  {/* <span className="h2 font-weight-bold mb-0">
                    <span className="text-success">  ({nameMatchAverage ?? "N/A"}%)</span>
                  </span> */}
               <span className="h2 font-weight-bold mb-0">
  <span className="text-success">
    ({calculatedMatchAverage ?? "N/A"}%)
  </span>
</span>


                </a>
              </div>
            </Row>
          </CardBody>
        </Card>
      </Col>

      <Modal
        id="nameValidationModal"
        isOpen={nameValidationModal}
        toggle={toggleNameValidationModal}
        size="lg"
      >
        <ModalHeader toggle={toggleNameValidationModal}>Name Validation</ModalHeader>
        <ModalBody>
          {loading ? (
            <span>Loading...</span>
          ) : documentData.length > 0 ? (
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Name 1</th>
                  <th>Name 2</th>
                  <th>Matched %</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {documentData.map((item) => (
                  <tr key={item.id}>
                    <td>{item.type}</td>
                    <td>{item.name1 || "null"}</td>
                    <td>{item.name2 || "null"}</td>
                    <td>{item.matched_percentage ?? "null"}</td>
                    <td>{item.matched_status ?? "Unknown"}</td>
                    <td>
                      <Button
                        size="sm"
                        color="primary"
                        onClick={() =>
                          handleRefreshRow(item.type, item.localIndex, item.id)
                        }
                        disabled={refreshingRowIds.has(item.id)}
                      >
                        {refreshingRowIds.has(item.id)
                          ? "Refreshing..."
                          : "Refresh"}
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <span>No document data available.</span>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleNameValidationModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Credit;
